import { useState, useEffect } from "react";
import { getActiveMessage, acknowledgeMessage } from "../lib/api";
import { Dialog, DialogContent } from "./ui/dialog";
import { Button } from "./ui/button";

export default function InAppMessageModal({ isAuthenticated, onAllDone }) {
  const [queue, setQueue] = useState([]);
  const [fetched, setFetched] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) return;
    getActiveMessage()
      .then(data => { if (Array.isArray(data) && data.length > 0) setQueue(data); })
      .catch(() => {})
      .finally(() => setFetched(true));
  }, [isAuthenticated]);

  useEffect(() => {
    if (fetched && queue.length === 0) onAllDone?.();
  }, [fetched, queue.length, onAllDone]);

  if (queue.length === 0) return null;

  const message = queue[0];

  const handleAcknowledge = async () => {
    try {
      await acknowledgeMessage(message.id);
      setQueue(q => q.slice(1));
    } catch (_) {
      // fail-safe : erreur réseau → modal reste ouverte
    }
  };

  return (
    <Dialog open={true}>
      <DialogContent
        className="max-w-md bg-[#0f0d0e] text-white border-white/10"
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <div className="mt-3 text-sm text-white/80 leading-relaxed whitespace-pre-wrap">
          {message.content}
        </div>
        <div className="flex justify-end mt-6">
          <Button
            className="bg-amber-500 hover:bg-amber-600 text-black"
            onClick={handleAcknowledge}
          >
            J'ai lu
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
